import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import { setAuth } from '../../utils/auth';

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await httpAction({ url: apis().authLogin, method: 'POST', body: form });
    setLoading(false);
    if (result?.status) {
      setAuth(result);
      navigate(location.state?.from?.pathname || '/admin', { replace: true });
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', gridTemplateColumns:'1.1fr .9fr', background: '#f5f7fb' }}>
      <div style={{ padding:'60px 8vw', display:'grid', alignContent:'center', background:'linear-gradient(135deg,#0f172a,#1d4ed8)', color:'#fff' }}>
        <div style={{ fontSize:14, letterSpacing:1.5, textTransform:'uppercase', opacity:.75 }}>RealCity Admin</div>
        <h1 style={{ fontSize:'clamp(2.4rem,5vw,4rem)', lineHeight:1.05, margin:'14px 0' }}>Secure control for listings, content, and operations.</h1>
        <p style={{ maxWidth:560, color:'rgba(255,255,255,.8)', fontSize:18 }}>Manage properties, blogs, reviews, partners, site settings, and incoming inquiries from one protected dashboard.</p>
      </div>
      <div style={{ display: 'grid', placeItems: 'center', padding: 20 }}>
        <form onSubmit={submitHandler} style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 20, padding: 28, boxShadow: '0 20px 50px rgba(0,0,0,.08)' }}>
          <div style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Admin Login</div>
          <p style={{ color: '#667085', marginBottom: 24 }}>Enter your credentials to access the dashboard.</p>
          <label style={{ display: 'block', marginBottom: 16 }}>
            <div style={{ marginBottom: 6, fontWeight: 600 }}>Email</div>
            <input value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})} type="email" required style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #d0d5dd' }} />
          </label>
          <label style={{ display: 'block', marginBottom: 20 }}>
            <div style={{ marginBottom: 6, fontWeight: 600 }}>Password</div>
            <input value={form.password} onChange={(e)=>setForm({...form, password:e.target.value})} type="password" required style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #d0d5dd' }} />
          </label>
          <button disabled={loading} type="submit" style={{ width: '100%', padding: 14, borderRadius: 12, border: 'none', background: '#0f5ef7', color: '#fff', fontWeight: 700 }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
          <div style={{ marginTop:16, color:'#98a2b3', fontSize:13 }}>Default seed admin comes from server environment variables.</div>
        </form>
      </div>
    </div>
  );
}
